import {getMethod, postMethod, putMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/orders', request, cancelToken)
}

async function put(id, request) {
    return await putMethod(`/api/orders/${id}`, request)
}

async function post(body) {
    return await postMethod('/api/orders', body)
}

export {get, put, post}
